import { render, staticRenderFns } from "./BizInsuranceInvoiceConfigModal.vue?vue&type=template&id=00c0adee&"
import script from "./BizInsuranceInvoiceConfigModal.vue?vue&type=script&lang=js&"
export * from "./BizInsuranceInvoiceConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports